import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-configurator-color-field',
  templateUrl: './color-field.component.html',
  styleUrls: ['./color-field.component.scss']
})
export class ColorFieldComponent {
  @Input() initialColor: String = '';
  @Input() label: String = '';
  @Input() labelID: String = '';
  @Input() opacity: Number = 100;

  constructor() {}
}
